import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../styles/reports-subscription/subscriptions.css";
import { selectUser } from "../../components/auth/auth.selector";
import { Container, Row, Col } from "react-bootstrap";
import { fetchAllSubscriptionData } from "../../redux/reducers/apiSlice";
import SubscriptionPageStructure from "./SubscriptionPageStructure";
import SubscriptionTableFIltrs from "./SubscriptionTableFIltrs";
import SubsTavViewTable from "./SubsTavViewTable";
import HelmetWrapper from "../../HelmetWrapper";
import { fetchOneDayPlansData } from "../../redux/plans-reducers/plansSlice";

const Subscriptions = () => {
  const dispatch = useDispatch();
  const decryptedText = useSelector(selectUser);

  const {
    allSubscriptionDataLoading,
    allSubscriptionDataError,
    allSubscriptionData,
  } = useSelector((state) => state.api);

  const isAdmin = decryptedText?.account_type === "admin";
  const isClusterManager = decryptedText?.account_type === "cluster_manager";

  // Check if user is a manager role (cluster_manager, fitness_manager, sales_manager, club_manager)
  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(decryptedText?.account_type);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const initialSubsTbFilters = {
    searchString: "",
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: decryptedText?.gym_name || "",
            value: decryptedText?.gym_id || "",
          }
        : "",
    selectedSubsType: "",
    selectedTrxType: "",
    selectedPlan: "",
    isActive: "",

    selectedCouplePlan: "",
    selLeadSource: "",
    selectedGender: "",

    selectedTransferType: "",
    selectedPauseStatus: "",

    selectedExperienceLevel: "",
    selectedPaymentLocation: "",
    selectedAllAccessPlan: "",
    selectedCheckoutSource: "",

    subsStartFrom: "",
    subsStartTo: "",

    subsCreateFrom: "",
    subsCreateTo: "",

    subsExpiringFrom: "",
    subsExpiringTo: "",
  };
  const [subsTbFilters, setSubsTbFilters] = useState(initialSubsTbFilters);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    keyword: subsTbFilters.selectedGym?.value || "",
    type: subsTbFilters.selectedSubsType?.value || "",
    duration: subsTbFilters.selectedPlan?.value || "",
    source_name: subsTbFilters.selLeadSource?.value || "",
    gender: subsTbFilters.selectedGender?.value || "",
    subscription_status: subsTbFilters.isActive?.value || "",
    is_couple: subsTbFilters.selectedCouplePlan?.value || "",
    transfered_type: subsTbFilters.selectedTransferType?.value || "",
    pause_status: subsTbFilters.selectedPauseStatus?.value || "",
    trx_id: subsTbFilters.selectedTrxType?.value || "",
    datefrom: subsTbFilters.subsStartFrom || "",
    dateto: subsTbFilters.subsStartTo || "",
    subscription_added_start_date: subsTbFilters.subsCreateFrom || "",
    subscription_added_end_date: subsTbFilters.subsCreateTo || "",
    expire_date: subsTbFilters.subsExpiringFrom || "",
    expire_date_to: subsTbFilters.subsExpiringTo || "",
    experience_level: subsTbFilters.selectedExperienceLevel?.value || "",
    payment_location: subsTbFilters.selectedPaymentLocation?.value || "",
    is_allgym_access: subsTbFilters.selectedAllAccessPlan?.value || "",
    checkout_source: subsTbFilters.selectedCheckoutSource?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const initialSubsTbData = {
    isPage: 0,
    pagination: [],
    totalNewPagination: [],
    totalRenewalPagination: [],

    allSubsData: [],
    newSusbcriptions: [],
    renewalSubscription: [],

    totalSubscription: "",
    totalAmount: 0,
    fullAmount: 0,
    partialAmount: 0,
    totalRenewals: 0,
    totalNew: 0,

    allPlanStats: {},
    allMaleFemaleBurification: {},
  };
  const [allSubsTbData, setAllSubsTbData] = useState(initialSubsTbData);

  const onClickReset = () => {
    setSubsTbFilters(initialSubsTbFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (subsTbFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: subsTbFilters.searchString }));
    }
  };

  function getAllSubscription(filters) {
    dispatch(
      fetchAllSubscriptionData({
        filters: filters,
        token: decryptedText?.token,
      })
    );
  }

  function getOneDaySubscription(filters) {
    dispatch(
      fetchOneDayPlansData({
        filters: filters,
        token: decryptedText?.token,
      })
    );
  }

  // useEffect(() => {
  //   setSubsTbFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin && !isClusterManager
  //       ? {
  //           label: decryptedText?.gym_name || "",
  //           value: decryptedText?.gym_id || "",
  //         }
  //       : "",
  //   }));
  // }, [decryptedText?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      keyword: subsTbFilters.selectedGym?.value || "",
      type: subsTbFilters.selectedSubsType?.value || "",
      duration: subsTbFilters.selectedPlan?.value || "",
      source_name: subsTbFilters.selLeadSource?.value || "",
      gender: subsTbFilters.selectedGender?.value || "",
      subscription_status: subsTbFilters.isActive?.value || "",
      is_couple: subsTbFilters.selectedCouplePlan?.value || "",
      transfered_type: subsTbFilters.selectedTransferType?.value || "",
      pause_status: subsTbFilters.selectedPauseStatus?.value || "",
      trx_id: subsTbFilters.selectedTrxType?.value || "",
      datefrom: subsTbFilters.subsStartFrom || "",
      dateto: subsTbFilters.subsStartTo || "",
      subscription_added_start_date: subsTbFilters.subsCreateFrom || "",
      subscription_added_end_date: subsTbFilters.subsCreateTo || "",
      expire_date: subsTbFilters.subsExpiringFrom || "",
      expire_date_to: subsTbFilters.subsExpiringTo || "",
      experience_level: subsTbFilters.selectedExperienceLevel?.value || "",
      payment_location: subsTbFilters.selectedPaymentLocation?.value || "",
      is_allgym_access: subsTbFilters.selectedAllAccessPlan?.value || "",
      checkout_source: subsTbFilters.selectedCheckoutSource?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    subsTbFilters.selectedGym,
    subsTbFilters.selectedSubsType,
    subsTbFilters.selectedPlan,
    subsTbFilters.selLeadSource,
    subsTbFilters.selectedGender,
    subsTbFilters.isActive,
    subsTbFilters.selectedCouplePlan,
    subsTbFilters.selectedTransferType,
    subsTbFilters.selectedPauseStatus,
    subsTbFilters.selectedTrxType,
    subsTbFilters.subsStartFrom,
    subsTbFilters.subsStartTo,
    subsTbFilters.subsCreateFrom,
    subsTbFilters.subsCreateTo,
    subsTbFilters.subsExpiringFrom,
    subsTbFilters.subsExpiringTo,
    subsTbFilters.selectedExperienceLevel,
    subsTbFilters.selectedPaymentLocation,
    subsTbFilters.selectedAllAccessPlan,
    subsTbFilters.selectedCheckoutSource,
  ]);

  useEffect(() => {
    getAllSubscription(filters);
    getOneDaySubscription(filters);
  }, [filters]);

  useEffect(() => {
    if (subsTbFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [subsTbFilters.searchString]);

  useEffect(() => {
    if (
      !allSubscriptionDataLoading &&
      !allSubscriptionDataError &&
      allSubscriptionData?.status
    ) {
      setAllSubsTbData((prevData) => ({
        ...prevData,
        pagination: allSubscriptionData?.pagination
          ? allSubscriptionData.pagination
          : [],
        totalNewPagination: allSubscriptionData?.totalNew_pagination
          ? allSubscriptionData.totalNew_pagination
          : [],
        totalRenewalPagination: allSubscriptionData?.totalRenewal_pagination
          ? allSubscriptionData.totalRenewal_pagination
          : [],

        allSubsData:
          allSubscriptionData?.data?.length > 0 ? allSubscriptionData.data : [],
        newSusbcriptions:
          allSubscriptionData?.total_new_Data?.length > 0
            ? allSubscriptionData.total_new_Data
            : [],
        renewalSubscription:
          allSubscriptionData?.total_renewal_Data?.length > 0
            ? allSubscriptionData.total_renewal_Data
            : [],

        totalSubscription: allSubscriptionData?.total_subscriptions
          ? allSubscriptionData.total_subscriptions
          : "",
        totalAmount: allSubscriptionData?.total_amount
          ? allSubscriptionData.total_amount
          : 0,
        fullAmount: allSubscriptionData?.full_amount
          ? allSubscriptionData.full_amount
          : 0,
        partialAmount: allSubscriptionData?.partial_amount
          ? allSubscriptionData.partial_amount
          : 0,
        totalRenewals: allSubscriptionData?.total_renewal
          ? allSubscriptionData.total_renewal
          : 0,
        totalNew: allSubscriptionData?.total_new
          ? allSubscriptionData.total_new
          : 0,
        totalRenewalsAmount: allSubscriptionData?.total_renewal_amount
          ? allSubscriptionData.total_renewal_amount
          : 0,
        totalNewAmount: allSubscriptionData?.total_new_amount
          ? allSubscriptionData.total_new_amount
          : 0,
        allPlanStats: {
          total_reg_monthly: allSubscriptionData?.total_reg_monthly,
          total_reg_quarterly: allSubscriptionData?.total_reg_quarterly,
          total_reg_half_yearly: allSubscriptionData?.total_reg_half_yearly,
          total_reg_yearly: allSubscriptionData?.total_reg_yearly,
          total_reg_monthly_amount:
            allSubscriptionData?.total_reg_monthly_amount,
          total_reg_quarterly__amount:
            allSubscriptionData?.total_reg_quarterly__amount,
          total_reg_half_yearly__amount:
            allSubscriptionData?.total_reg_half_yearly__amount,
          total_reg_yearly__amount:
            allSubscriptionData?.total_reg_yearly__amount,
          total_oneday_subscriptions:
            allSubscriptionData?.total_oneday_subscriptions,
          total_reg_allaccess: allSubscriptionData?.total_reg_allaccess,
          total_reg_allaccess__amount:
            allSubscriptionData?.total_reg_allaccess__amount,
        },
        allMaleFemaleBurification: {
          total_couple: allSubscriptionData?.total_couple,
          total_couple_amount: allSubscriptionData?.total_couple_amount,
          total_female: allSubscriptionData?.total_female,
          total_male: allSubscriptionData?.total_male,
          total_new_female: allSubscriptionData?.total_new_female,
          total_new_male: allSubscriptionData?.total_new_male,
          total_renewal_female: allSubscriptionData?.total_renewal_female,
          total_renewal_male: allSubscriptionData?.total_renewal_male,
        },
      }));
    } else {
      setAllSubsTbData(initialSubsTbData);
    }
  }, [
    allSubscriptionData,
    allSubscriptionDataLoading,
    allSubscriptionDataError,
  ]);

  return (
    <HelmetWrapper title="WTF: Subscription">
      <Container className="bg-cloud-k px-50px subscription-container" fluid>
        <Row>
          <Col>
            <SubscriptionPageStructure
              decryptedText={decryptedText}
              callSubscription={() => {
                getAllSubscription(filters);
                getOneDaySubscription(filters);
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <SubscriptionTableFIltrs
              allSubsTbData={allSubsTbData}
              allSubsPlanStatsData={allSubsTbData.allPlanStats}
              allMaleFemaleBurification={
                allSubsTbData.allMaleFemaleBurification
              }
              decryptedText={decryptedText}
              subsTbFilters={subsTbFilters}
              setSubsTbFilters={setSubsTbFilters}
              onClickSearch={onClickSearch}
              onClickReset={onClickReset}
              searchFilterApplied={searchFilterApplied}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <SubsTavViewTable
              decryptedText={decryptedText}
              allSubsTbData={allSubsTbData}
              setAllSubsTbData={setAllSubsTbData}
              callFunction={() => {
                getAllSubscription(filters);
                getOneDaySubscription(filters);
              }}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default Subscriptions;
